<template>
  <div style="padding: 20px">
    <v-card>
      <v-toolbar
        class="indigo white--text"
        dense
        primary-title
      >
        <v-toolbar-title>Picking</v-toolbar-title>

        <v-spacer></v-spacer>

        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              v-on="on"
              small
              elevation="1"
              class="mr-10"
              @click="aggiungiDaArticolo"
            >
              <v-icon
                small
                color="#1a80b6"
              >
                mdi-plus
              </v-icon>
              <v-icon color="#1a80b6">
                mdi-file
              </v-icon>
            </v-btn>
          </template>
          <span>Aggiungi da articolo</span>
        </v-tooltip>

        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              v-on="on"
              small
              elevation="1"
              class="mr-10"
              @click="aggiungiDaOrdine"
            >
              <v-icon
                small
                color="#1a80b6"
              >
                mdi-plus
              </v-icon>
              <v-icon color="#1a80b6">
                mdi-cart
              </v-icon>
            </v-btn>
          </template>
          <span>Aggiungi da ordine</span>
        </v-tooltip>

        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              v-on="on"
              small
              elevation="1"
              @click="salvaPicking"
            >
              <v-icon class="success--text">
                mdi-floppy
              </v-icon>
            </v-btn>
          </template>
          <span>Salva Distinta</span>
        </v-tooltip>

        <v-spacer></v-spacer>

        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              v-on="on"
              small
              elevation="1"
              @click="$router.push({ name: 'HomePicking' })"
            >
              <v-icon class="error--text">
                mdi-keyboard-backspace
              </v-icon>
            </v-btn>
          </template>
          <span>Indietro</span>
        </v-tooltip>
      </v-toolbar>

      <v-card-text>
        <v-row>
          <v-col>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <v-dialog v-model="add_articolo_visible" width="800">
      <v-card>
        <v-toolbar class="indigo white--text" dense>
          <v-toolbar-title class="white--text">
            Aggiungi da articolo
          </v-toolbar-title>

          <v-spacer></v-spacer>

          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                v-on="on"
                small
                @click="salvaAddArticoloDialog"
              >
                <v-icon color="#1a80b6">
                  mdi-floppy
                </v-icon>
              </v-btn>
            </template>
            <span>Salva e chiudi</span>
          </v-tooltip>

          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                v-on="on"
                small
                elevation="1"
                class="ml-10"
                @click="toggleAddArticoloFilters"
              >
                <v-icon color="purple">
                  mdi-filter
                </v-icon>
              </v-btn>
            </template>
            <span>Filtri</span>
          </v-tooltip>

          <v-spacer></v-spacer>

          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                v-on="on"
                @click="chiudiAddArticoloDialog"
                small
              >
                <v-icon class="error--text">
                  mdi-close
                </v-icon>
              </v-btn>
            </template>
            <span>Chiudi</span>
          </v-tooltip>
        </v-toolbar>

        <v-card-text class="pa-0 pt-3">
          <v-container>
            <v-row v-if="show_add_articolo_filters">
              <v-col>
                <v-row>
                  <v-col class="flex-grow-1 flex-shrink-0">
                    <v-text-field
                      label="Codice articolo"
                      dense
                      outlined
                      clearable
                      v-model="codice_articolo"
                    >
                    </v-text-field>
                  </v-col>
                  <v-col class="flex-grow-0 flex-shrink-1">
                    <v-btn
                      class="mr-2"
                      elevation="1"
                      @click="searchByCodiceOrdine"
                    >
                      <v-icon color="#1a80b6">mdi-magnify</v-icon>
                    </v-btn>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>

            <v-row>
              <v-col>
                <v-data-table
                  :headers="tableArticoliheaders"
                  :items="articoli"
                  show-select
                >
                  <template v-slot:[`item.quantita`]="props">
                    <v-edit-dialog
                      :return-value.sync="props.item.quantita"
                    >
                      {{ props.item.quantita }}
                      <template v-slot:input>
                        <v-text-field
                          v-model="props.item.quantita"
                          label="Edit"
                          single-line
                          type="number"
                          min="1"
                        ></v-text-field>
                      </template>
                    </v-edit-dialog>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="add_ordine_visible" width="800">
      <v-card>
        <v-toolbar class="indigo white--text" dense>
          <v-toolbar-title class="white--text">
            Aggiungi da ordine
          </v-toolbar-title>

          <v-spacer></v-spacer>

          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                v-on="on"
                small
                @click="salvaAddOrdineDialog"
              >
                <v-icon color="#1a80b6">
                  mdi-floppy
                </v-icon>
              </v-btn>
            </template>
            <span>Salva e chiudi</span>
          </v-tooltip>

          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                v-on="on"
                small
                elevation="1"
                class="ml-10"
                @click="toggleAddOrdineFilters"
              >
                <v-icon color="purple">
                  mdi-filter
                </v-icon>
              </v-btn>
            </template>
            <span>Filtri</span>
          </v-tooltip>

          <v-spacer></v-spacer>

          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                v-on="on"
                @click="chiudiAddOrdineDialog"
                small
              >
                <v-icon class="error--text">
                  mdi-close
                </v-icon>
              </v-btn>
            </template>
            <span>Chiudi</span>
          </v-tooltip>
        </v-toolbar>

        <v-card-text class="pa-0 pt-3">
          <v-container>
            <v-row v-if="show_add_ordine_filters">
              <v-col>
                <v-row>
                  <v-col class="flex-grow-1 flex-shrink-0">
                    <v-text-field
                      label="Codice ordine"
                      dense
                      outlined
                      clearable
                      v-model="codice_ordine"
                    >
                    </v-text-field>
                  </v-col>
                  <v-col class="flex-grow-0 flex-shrink-1">
                    <v-btn
                      class="mr-2"
                      elevation="1"
                      @click="searchByCodiceOrdine"
                    >
                      <v-icon color="#1a80b6">mdi-magnify</v-icon>
                    </v-btn>
                  </v-col>
                </v-row>
              </v-col>

              <v-col>
                <v-row>
                  <v-col class="flex-grow-1 flex-shrink-0">
                    <v-text-field
                      label="Partner"
                      dense
                      outlined
                      clearable
                      v-model="partner"
                    >
                    </v-text-field>
                  </v-col>
                  <v-col class="flex-grow-0 flex-shrink-1">
                    <v-btn
                      class="mr-2"
                      elevation="1"
                      @click="searchByPartner"
                    >
                      <v-icon color="#1a80b6">mdi-magnify</v-icon>
                    </v-btn>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>

            <v-row>
              <v-col>
                <v-data-table
                  :headers="tableOrdiniheaders"
                  :items="ordini"
                  show-expand
                  show-select
                  v-model="ordiniSelected"
                  @toggle-select-all="selectAll"
                >
                  <template v-slot:expanded-item="{ headers, item }">
                    <td
                      :colspan="headers.length"
                      class="pa-0"
                      style="background-color: white;"
                    >
                      <v-data-table
                        :headers="subHeaders"
                        :items="item.articoli"
                        hide-default-footer
                        class="elevation-1 pl-10"
                        show-select
                        v-model="item.articoliSelected"
                      >
                        <template v-slot:[`item.quantita`]="props">
                          <v-edit-dialog
                            :return-value.sync="props.item.quantita"
                          >
                            {{ props.item.quantita }}
                            <template v-slot:input>
                              <v-text-field
                                v-model="props.item.quantita"
                                label="Edit"
                                single-line
                                type="number"
                                min="1"
                              ></v-text-field>
                            </template>
                          </v-edit-dialog>
                        </template>
                      </v-data-table>
                    </td>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: 'AddPicking',
  data() {
    return {
      add_articolo_visible: false,
      add_ordine_visible: false,
      show_add_articolo_filters: true,
      show_add_ordine_filters: true,
      codice_articolo: null,
      codice_ordine: null,
      partner: null,
      ordiniSelected: [],
      tableArticoliheaders: [
        {
          text: 'Cod. Articolo',
          value: 'cod_articolo',
        },
        {
          text: 'Descrizione',
          value: 'des_articolo',
        },
        {
          text: 'Giacenza',
          value: 'giacenza',
        },
        {
          text: 'Quantità da prelevare',
          value: 'quantita',
        },
      ],
      tableOrdiniheaders: [
        {
          text: 'Partner',
          value: 'partner',
        },
        {
          text: 'Codice ordine',
          value: 'cod_ordine',
        },
        {
          text: 'Data ordine',
          value: 'data_ordine',
        },
        {
          text: 'N. righe',
          value: 'numero_righe',
          sortable: false,
        },
        {
          text: '',
          value: 'data-table-expand',
        },
      ],
      subHeaders: [
        {
          text: 'Descrizione',
          value: 'des_articolo',
        },
        {
          text: 'Qnt',
          value: 'quantita',
        },
      ],
      articoli: [
        {
          id: 1,
          cod_articolo: 'A123',
          des_articolo: 'Barra flex A5',
          giacenza: 2,
          quantita: 2,
        },
        {
          id: 2,
          cod_articolo: 'A123',
          des_articolo: 'Barra flex A5',
          giacenza: 3,
          quantita: 3,
        }
      ],
      ordini: [
        {
          id: 1,
          cod_ordine: 'ORD001',
          data_ordine: '12/09/21',
          numero_righe: 5,
          partner: 'Azienda Alpha',
          articoli: [
            {
              id: 1,
              des_articolo: 'Barra alluminio 126789ag',
              quantita: 5,
            },
            {
              id: 2,
              des_articolo: 'Barra alluminio 126789ag',
              quantita: 2,
            },
            {
              id: 3,
              des_articolo: 'Barra alluminio 126789ag',
              quantita: 2,
            },
            {
              id: 4,
              des_articolo: 'Barra inox BECX56',
              quantita: 10,
            },
            {
              id: 5,
              des_articolo: 'Barra alluminio BECX56',
              quantita: 11,
            },
          ],
          articoliSelected: [],
        },
        {
          id: 2,
          cod_ordine: 'ORD002',
          data_ordine: '12/09/21',
          numero_righe: 3,
          partner: 'Azienda Beta',
          articoli: [
            {
              id: 1,
              des_articolo: 'Barra alluminio 126789ag',
              quantita: 5,
            },
            {
              id: 2,
              des_articolo: 'Barra alluminio 126789ag',
              quantita: 2,
            },
            {
              id: 3,
              des_articolo: 'Barra alluminio 126789ag',
              quantita: 2,
            },
          ],
          articoliSelected: [],
        },
        {
          id: 3,
          cod_ordine: 'ORD003',
          data_ordine: '12/09/21',
          numero_righe: 2,
          partner: 'Azienda Tre',
          articoli: [
            {
              id: 1,
              des_articolo: 'Barra alluminio 126789ag',
              quantita: 5,
            },
            {
              id: 2,
              des_articolo: 'Barra alluminio 126789ag',
              quantita: 2,
            },
          ],
          articoliSelected: [],
        },
      ],
    };
  },
  watch: {
    ordiniSelected(newValue, oldValue) {
      const added = newValue.filter(({ id: id1 }) => !oldValue.some(({ id: id2 }) => id2 === id1));
      if (added.length === 1) {
        const item = added[0];
        item.articoli.forEach((articolo) => {
          item.articoliSelected.push(articolo);
        });
      }

      const removed = oldValue.filter(({ id: id1 }) => !newValue.some(({ id: id2 }) => id2 === id1));
      if (removed.length === 1) {
        const item = removed[0];
        item.articoliSelected = [];
      }
    },
  },
  methods: {
    salvaPicking() {
    },
    aggiungiDaArticolo() {
      this.add_articolo_visible = true;
    },
    aggiungiDaOrdine() {
      this.add_ordine_visible = true;
    },
    chiudiAddArticoloDialog() {
      this.add_articolo_visible = false;
      this.show_add_articolo_filters = true;
    },
    chiudiAddOrdineDialog() {
      this.add_ordine_visible = false;
      this.show_add_ordine_filters = true;
    },
    salvaAddArticoloDialog() {
      this.add_articolo_visible = false;
      this.show_add_articolo_filters = true;
    },
    salvaAddOrdineDialog() {
      this.add_ordine_visible = false;
      this.show_add_ordine_filters = true;
    },
    toggleAddArticoloFilters() {
      this.show_add_articolo_filters = !this.show_add_articolo_filters;
    },
    toggleAddOrdineFilters() {
      this.show_add_ordine_filters = !this.show_add_ordine_filters;
    },
    searchByCodiceOrdine() {

    },
    searchByPartner() {

    },
    selectAll(event) {
      if (event.value) {
        this.ordini.forEach((item) => {
          item.articoliSelected = [];
          item.articoli.forEach((articolo) => {
            item.articoliSelected.push(articolo);
          });
        });
      } else {
        this.ordini.forEach((item) => {
          item.articoliSelected = [];
        });
      }
    },
  },
};
</script>
